import api from './index'
import type { GeolocationResult } from '@/types'

const CLOUDFLARE_WORKER_URL = 'https://fragrant-fog-f988.ryan-v-0b2.workers.dev/'
const IPSTACK_URL = 'https://api.ipstack.com/check'
const IPSTACK_KEY = 'df027d9a9416448d23a42df11a08961c'

export async function getGeolocation(): Promise<GeolocationResult> {
  try {
    // Primary: Cloudflare Worker
    const response = await api.get(CLOUDFLARE_WORKER_URL, { timeout: 5000 })

    return {
      ip: response.data.ip || '',
      city: response.data.city || '',
      state: response.data.region || '',
      zip: response.data.zip || '',
    }
  } catch (error) {
    console.error('Primary geolocation error:', error)
    return await fallbackGeolocation()
  }
}

async function fallbackGeolocation(): Promise<GeolocationResult> {
  try {
    const response = await api.get(IPSTACK_URL, {
      params: { access_key: IPSTACK_KEY },
      timeout: 5000,
    })

    return {
      ip: response.data.ip || '',
      city: response.data.city || '',
      state: response.data.region_code || '',
      zip: response.data.zip || '',
    }
  } catch (error) {
    console.error('Fallback geolocation error:', error)
    return { ip: '', city: '', state: '', zip: '' }
  }
}
